import { useDialog } from '@mews/framework';
import { Avatar, Dialog, Image } from '@optimus-web/core';

interface PreviewAvatarProps {
    // empty string means no image
    imgSrc: string;
    title: string;
}

export const PreviewAvatar = ({ imgSrc, title }: PreviewAvatarProps) => {
    const [{ active, onClose }, toggleDialog] = useDialog();

    return (
        <>
            <Avatar src={imgSrc} title={title} size="medium" onClick={imgSrc ? toggleDialog : undefined} />
            <Dialog size="small" title={title} active={active} onClose={onClose}>
                <Image src={imgSrc} alt={title} style={{ borderRadius: '100%' }} />
            </Dialog>
        </>
    );
};
